export const Endpoints = {
  checkFinanceDocuments: (token: string) => { return `/orders/checkFinanceDocuments?token=${token}` },
  uploadDocuments: "/orders/upload/finance"
}